import { McpServiceComponent } from './McpServiceComponent';
import { AppConnectionStatuses } from '../../../../constants/appConnectionStatuses';
export const McpReconnectionConfig = {
  reconnectButton: null,
  serviceComponent: McpServiceComponent,
  statusesForDisplaying: [AppConnectionStatuses.DISCONNECTED]
};